import { render, staticRenderFns } from "./HowXt.vue?vue&type=template&id=159f41ac&scoped=true"
import script from "./HowXt.vue?vue&type=script&lang=ts"
export * from "./HowXt.vue?vue&type=script&lang=ts"
import style0 from "./HowXt.vue?vue&type=style&index=0&id=159f41ac&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159f41ac",
  null
  
)

export default component.exports